export const navigateToUtil = (route: string, navigateFn: any, currLocation: string) => {
    if (currLocation.includes("dcui") && !route.includes("dcui")) {
        navigateFn(`/dcui${route}`);
    } else {
        navigateFn(route);
    }
};